<template>
  <!-- he who has a why can bear any how -->
  <div
    :id="stageSettings.canvasScaleMethod === 'fit'
      ? 'stage-parent-fit'
      : 'stage-parent-scroll'"
    :class="{ 'stage-edit-mode-active' : visionboard_edit_mode }">

    <v-stage
      ref="stage"
      id="stage-container"
      :config="stageSettings"
      @wheel="onWheel"
      @mousedown="handleStageClickOrTap"
      @tap="handleStageClickOrTap">

      <v-layer ref="layer" :config="{ draggable: true }">

        <v-rect
          :config="{
            x: -200000,
            y: -200000,
            width:  200000*2,
            height: 200000*2,
            /* fill:   'rgba(255,128,0,0.5)', */
            fill:   stageSettings.backgroundColor,
          }"
          @mousedown="handleStageClickOrTap"
          @tap="handleStageClickOrTap" />

        <v-clock
          v-show="FEATURE_SHOW_CLOCK"
          :x="1400"
          :y="20"
          :editable="visionboard_edit_mode"
          @select="handleClickOrTap"
          />

        <v-quote
          v-show="FEATURE_SHOW_QUOTE_OF_THE_DAY"
          :x="1220"
          :y="80"
          :editable="visionboard_edit_mode"
          @select="handleClickOrTap"
          />

        <!-- TODO: this should go in to a new component VTextGroup.vue -->
        <!-- TODO: mouse over -->
        <v-text-group
          v-for="item in texts"
          :key="item.id"
          :item="item"
          :editable="visionboard_edit_mode"
          @select="handleClickOrTap"
          @update-position="onDragendText" />

        <!-- TODO: goal_list_ids, aber sortier nach z-index -->
        <template v-if="stageSettings.groupItems">
          <v-goal v-for="goal in all_my_user_goal_settings"
            :key="goal.$id"
            :goal-id="goal.$id"
            :goal-settings="goal"
            :stage-settings="stageSettings"
            :is-selected="selection.goalId === goal.$id"
            :editable="visionboard_edit_mode"
            @edit-goal="onEditGoal"
            @select="handleClickOrTap"
            @add-commitment="onAddCommitment" />
            <!-- :transformerNode="getTransformer" -->
        </template>

        <template v-else>
          <template v-for="goal in all_my_user_goal_settings">
            <v-goal-headline
              :key="'headline-'+goal.$id"
              :goal-id="goal.$id"
              :goal-settings="goal"
              :stage-settings="stageSettings"
              :is-selected="selection.goalId === goal.$id && selection.type === 'headline'"
              :editable="visionboard_edit_mode"
              @select="handleClickOrTap" />

            <v-goal-image
              :key="'image-'+goal.$id"
              :goal-id="goal.$id"
              :goal-settings="goal"
              :stage-settings="stageSettings"
              :is-selected="selection.goalId === goal.$id && selection.type === 'image'"
              :editable="visionboard_edit_mode"
              @select="handleClickOrTap"
              @add-commitment="onAddCommitment"
              @on-snap="onSnapText" />

            <!-- TODO: implement elements
            <v-goal-commitments
              :key="'commitments-'+goal.$id"
              :goal-id="goal.$id"
              :goal-settings="goal"
              :stageSettings="stageSettings"
              :is-selected="selectedGoal === goal.$id && selectedPart === 'commitments'"
              @click-group="handleClickOrTap /* TODO */" />
            -->
          </template>
        </template>

        <!-- <template v-if="all_my_user_goal_settings.length > 0">
        </template> -->

        <template v-if="all_my_user_goal_settings.length === 0">
          <!-- show text when user has no goals -->
          <v-text :config="{
            fill:           '#A0A0A0',
            width:          200,
            x:              stageSettings.width/2,
            y:              stageSettings.height/2,
            align:          'center',
            verticalAlign:  'middle',
            fontSize:       26,
            fontStyle:      'bold',
            text:           'Welcome! Please add some goals :-)'
          }" />
        </template>

        <v-transformer ref="transformer" :config="{
          anchorStroke: 'white',
          anchorFill: 'green',
          borderStroke: 'green',
          borderDash: [3, 3],
          resizeEnabled: selection.type === 'group' /* true */,
          rotateEnabled: true,
          rotationSnaps: [0, 45, 90, 135, 180, 225, 270, 315],
          keepRatio: true,
          anchorSize: 15,
          anchorCornerRadius: 1,
          enabledAnchors: ['bottom-left', 'bottom-right', 'top-left', 'top-right'],
          boundBoxFunc: boundBoxFunc
          //centeredScaling: true,
          }"
        />

        <!--
        TODO: convert to konva:
        <div
          v-for="(invitation, invitation_idx) in goal_invite_list"
          :key="'invitation'+invitation_idx">
          <div class="list invite-list">
            <header> {{invitation.cachedGoalName}} </header>
            <ul>
              <li>
                You got an invitation to <strong>{{invitation.cachedGoalName}}</strong>
                from <strong>{{invitation.cachedSenderName}}.</strong><br /><br />
                <span>{{invitation.invitedAt|calendarDateFromFirebase}}</span>
              </li>
            </ul>
            <footer>
              <el-button @click="onAcceptInvitation(invitation.id, invitation.cachedGoalName, true)">Accept</el-button>
              <el-button @click="onAcceptInvitation(invitation.id, invitation.cachedGoalName, false)" variant="danger">Decline</el-button>
            </footer>
          </div>
        </div>
        -->

      </v-layer>

      <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->

      <v-layer ref="layer_overlay" :config="{}">
        <v-rect
          v-if="visionboard_edit_mode"
          :config="{
            x: 0,
            y: 0,
            width: stageWidth,
            height: stageHeight,
            stroke: 'rgba(255,0,0,0.5)',
            strokeWidth: 12,
            hitFunc: () => false
          }" />

        <v-button
          :x="10"
          :y="stageHeight - 45"
          :theme="visionboard_edit_mode ? 'red' : 'blue'"
          @click="toggleVisionboardEditMode"
          :buttonText="visionboard_edit_mode ? 'Exit edit mode' : 'Enter edit mode'"
          />

        <v-button
          v-if="!visionboard_edit_mode"
          :x="stageWidth - 180 - 10"
          :y="stageHeight - 45"
          theme="blue"
          @click="toggleVisionboardChallengeSidebar"
          :buttonText="visionboard_challenge_sidebar ? 'Hide challenges' : 'Show challenges'"
          />

        <v-icon
          :x="stageWidth - 70"
          :y="10"
          @click="onResetView"
          buttonText="100%"
          iconName=""
          iconType="" />

        <v-icon
          :x="10"
          :y="10"
          @click="onShowSettingsModal"
          buttonText="Visionboard Settings"
          iconName="editSettingsIcon"
          iconType="settings" />

        <v-icon
          :x="10"
          :y="50"
          @click="$root.showNewModal('goal', { isTeamgoal: false })"
          buttonText="Add Goal"
          iconName="addGoalIcon"
          iconType="add" />

        <v-icon
          :x="10"
          :y="90"
          @click="onAddText"
          iconName="addTextIcon"
          buttonText="Add Text"
          iconType="add" />

        <!--
        <v-icon
          :x="10"
          :y="130"
          iconName="addCommitmentIcon"
          buttonText="Add Commitment"
          iconType="add" />
        -->
      </v-layer>

    </v-stage>

    <div class="visionboard-sidebar-container" v-if="visionboard_edit_mode">
      <VisionboardSidebar :selection="selection" @text-update="onHandleTextUpdate" />
    </div>
    <div class="visionboard-sidebar-container" v-if="visionboard_challenge_sidebar">
      <VisionboardChallengeSidebar />
    </div>

    <el-card class="m-4" v-if="SHOW_DEBUG">
      <pre>{{stageSettings}}</pre>
      <pre>stageWidth: {{stageWidth}}</pre>
      <pre>stageHeight: {{stageHeight}}</pre>

      <el-button @click="onSaveCustomText">SAVE ALL TEXT</el-button>
      <pre><portal-target name="visionboard-debug" multiple></portal-target></pre>
      <!-- <pre>{{goals}}</pre> -->
      <!-- <pre>{{ timeslot_collection_list  }}</pre> -->
      <!-- <pre> timeslot_collection_list.map(item => item.name)</pre> -->
      <!-- <pre>all_my_user_goal_settings: {{all_my_user_goal_settings}}</pre> -->
      <pre>{{all_my_user_goal_settings.map( item => item.sortidx + ' ' + item.cachedName )}}</pre>
      <!-- <pre>{{customTextClone}}</pre> -->
    </el-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import util from "@/util";
import debounce from 'lodash.debounce';
import clonedeep from 'lodash.clonedeep'
import CanvasExportMixin from "./Mixins/CanvasExport";
import VisionboardSidebar from "./Components/VisionboardSidebar"
import VisionboardChallengeSidebar from './Components/VisionboardChallengeSidebar'

import VGoal from './Elements/VGoal'
import VIcon from './Elements/VIcon'
import VButton from './Elements/VButton'
import VGoalHeadline from './Elements/VGoalHeadline'
import VGoalImage from './Elements/VGoalImage'
// import VGoalCommitments from './Elements/VGoalCommitments'
import VTextGroup from './Elements/VTextGroup'
import VClock from './Elements/VClock'
import VQuote from './Elements/VQuoteOfTheDay'

import {
  FEATURE_SHOW_CLOCK,
  FEATURE_SHOW_QUOTE_OF_THE_DAY,
  ENABLE_VISIONBOARD_WHEEL_ZOOM } from '@/features'

/* Anmerkungen
   ===========
   - zIndex = sortidx

   TODO:
   ====
   - ZIndex funktioniert nicht
*/

const SAVE_TEXT_THROTTLE_TIME = 1000;

export default {
  mixins: [ CanvasExportMixin ],
  props: {
    visionboardId: {}
  },
  data() {
    return {
      FEATURE_SHOW_CLOCK,
      FEATURE_SHOW_QUOTE_OF_THE_DAY,
      selection: {},
      customTextClone: [],
      stageHeight: 0,
      stageWidth: 0,
      zoom: 0,
    };
  },
  mounted() {
    this.onLoadCustomText();
    this.initCanvas(this.stageSettings);
    this.resizeListener = () => {
      if ( this.$route.name === 'visionboard' ) {
        this.fitStageIntoParentContainer( this.stageSettings );
      }
    };
    window.addEventListener('resize', this.resizeListener);

    /* Wait 2 seconds before taking screenshot to reduce load */
    setTimeout(() => this.onGeneratePreviewImage(), 2000);
  },
  beforeDestroy() {
    if ( this.resizeListener ) {
      window.removeEventListener('resize', this.resizeListener)
    }
  },
  watch: {
    visionboard_edit_mode( value ) {
      if ( !value ) {
        // this.getTransformer.detach();
        this.handleClickOrTap({ type: 'nothing' });
      }
      this.resizeListener();
    },
    visionboard_challenge_sidebar( value ) {
      this.resizeListener();
    }
  },
  computed: {
    ...mapGetters("user", [
      "userData"
    ]),
    ...mapGetters("app", [
      'visionboard_edit_mode',
      'visionboard_challenge_sidebar'
    ]),

    user_goal_settings() {
      return this.$models.userGoalSettings.subscribeList();
    },

    // all_my_user_goal_settings() {
    //   let goal_list = this.$models.userGoalSettings.subscribeList();
    //   return goal_list.itemsAsArray().filter( item => !item.deleted )
    // },

    goal_meta_map() {
      /* The reason why we create a (cached) map here, is that currently goals
         can not be loaded as list, which would require a method 'goal_meta(id)',
         to get goal meta data, but methods are not cached. */
      let goal_meta_map = {}
      for ( var goalSettingsId in this.user_goal_settings.items ) {
        if ( !goalSettingsId ) {
          continue
        }
        let goalMeta = this.$models.goalMeta.getNode( goalSettingsId );
        goal_meta_map[ goalSettingsId ] = {
          team:    goalMeta.isTeamgoal || false,
          deleted: goalMeta.deleted || false
        }
      }
      return goal_meta_map
    },

    all_my_user_goal_settings() {
      const map = this.goal_meta_map
      return this.user_goal_settings
        .itemsAsArray()
        .filter( item => !map[ item.$id ].deleted )
    },

    my_user_goal_settings() {
      const map = this.goal_meta_map
      return this.user_goal_settings
        .itemsAsArray()
        .filter( item => !map[ item.$id ].deleted && !map[ item.$id ].team )
    },

    team_user_goal_settings() {
      const map = this.goal_meta_map
      return this.user_goal_settings
        .itemsAsArray()
        .filter( item => !map[ item.$id ].deleted && map[ item.$id ].team )
    },

    getTransformer() {
      // console.log("getTransformer", this.$refs.transformer);
      return this.$refs.transformer.getNode();
    },

    // goals() {
    //   // console.log("all_my_user_goal_settings", this.all_my_user_goal_settings);
    //   // let goals = challengeData.goals;
    //   // console.log("goals", goals)
    //   // return goals;
    //
    //   return this.all_my_user_goal_settings;
    // },

    texts() {
      return this.customTextClone;
      /*.map(item => {
        let defaultTextSettings = {
          fontFamily: "Arial",
          fontSize: 24,
          fill: '#ffffff',
        };
        return Object.assign({}, defaultTextSettings, item, {
          draggable: true,
          showText: true,
        });
      }); */
    },

    stageSettings() {
      const defaultSettings = {
        canvasScaleMethod: 'scroll',
        backgroundColor: '#000000',
        width: 1500,
        height: 800,
        allHeadlinesFontSize: 24,
        allCommitmentsFontSize: 15,
        showAllCommitments: true,
        showAllHeadlines: true,
        showAllProgress: true,
        groupItems: true,
        // stageSize: {
        //   width: window.innerWidth,
        //   height: 800
        // },
        container: 'stage-container',
        // draggable: true,
      };
      let userSettings = this.$models.userSettings.getData( this.$models.user.defaultUserId )
      if ( userSettings && 'visionboardSettings' in userSettings) {
        return Object.assign({}, defaultSettings, userSettings.visionboardSettings);
      } else {
        /* If the user doesnt have a visionboardSettings field yet, return
           default values. To be removed in the future, since all users should
           have this field */
        console.log("stageSettings - Fallback to default");
        return defaultSettings;
      }
    },

    /*
    goal_invite_list() {
      let user = this.userData;
      if (user && 'goalInviteList' in user) {
        return Object.keys(user.goalInviteList).map(key => {
          return { ...user.goalInviteList[key], id: key };
        });
      } else {
        return [];
      }
    }
    */

  },
  methods: {
    ...mapActions("app", [
      'toggleVisionboardEditMode',
      'toggleVisionboardChallengeSidebar'
    ]),

    onLoadCustomText() {
      if ( this.userData  && 'visionboardSettings' in this.userData) {
        let settings = this.userData.visionboardSettings;
        if ( settings && settings.customText ) {
          // this.customTextClone = Object.assign({}, settings.customText)
          this.customTextClone = clonedeep( settings.customText );
        }
        console.log("[VB] onLoad", this.customTextClone );
      } else {
        console.log("[VB] onLoad - visionboardSettings.customText does not exist yet");
      }
    },

    onDragendText(positionData, textId) {
      // console.log("event", x, y, textId, this.customTextClone);
      let idx = this.customTextClone.findIndex( item => item.textId === textId );
      if ( idx !== -1 ) {
        this.customTextClone[ idx ].x = positionData.x;
        this.customTextClone[ idx ].y = positionData.y;
        this.customTextClone[ idx ].rotation = positionData.rotation;
        // this.customTextClone[ idx ].scaleX = positionData.scaleX;
        // this.customTextClone[ idx ].scaleY = positionData.scaleY;
      }

      this.onSaveCustomText();
    },

    onAddText() {
      this.$root.showNewModal('text-visual').then(({ action, data }) => {
        if ( action === 'save' ) {
          this.addOrUpdateText(data);
        }
      });
    },

    addOrUpdateText(data) {
      console.log("addOrUpdateText", data);
      if ( !data.textId ) {
        let newTextId = util.get_new_uuid();
        data = Object.assign({}, data, {
          textId: newTextId,
          // text: data.text, // 'bla bla bla', // this.newText,
          fontFamily: "Arial",
          fontSize: 24,
          x: 80,
          y: 80,
          // fill: '#ffffff',
          // draggable: true,
          // showText: true,
        })
        console.log("** pushing data", data);
        this.customTextClone.push(data);
      } else {
        let idx = this.customTextClone.findIndex( item => item.textId === data.textId );
        if ( idx !== -1 ) {
          // this.customTextClone[ idx ] =
          Object.assign(this.customTextClone[ idx ], data);
            // textId text fontSize fontFace
        }
      }

      this.onSaveCustomText();
    },

    onSaveCustomText: debounce(function () {
      // INFO: Has to be function, because lodash will bind it to this
      console.log("onSaveSettings", this.customTextClone);
      this.$api.user_update_settings_by_prefix({
        data: {
          customText: this.customTextClone
        },
        prefix: 'visionboardSettings'
      }).then(() => {
        console.log( "Successfully updated user visionboardSettings" );
        this.stageSettingsFormVisible = false;
      });
    }, SAVE_TEXT_THROTTLE_TIME),

    initCanvas(stageSettings) {
      console.log("[VB] initCanvas", stageSettings);
      let konvaComp = document.getElementsByClassName('konvajs-content')[0];
      if ( konvaComp ) {
        konvaComp.style.backgroundColor = stageSettings.backgroundColor;
      }

      /* HACK: problem #stage-parent-fit is not assigned yet */
      this.stageSettings.canvasScaleMethod = stageSettings.canvasScaleMethod;
      this.$nextTick(() => {
        this.fitStageIntoParentContainer(stageSettings);
      });
    },

    fitStageIntoParentContainer(stageSettings) {

      const FIT_CANVAS_HEIGHT = true;
      const FIT_CANVAS_WIDTH = ENABLE_VISIONBOARD_WHEEL_ZOOM;

      if ( !this.$refs.stage ) {
        // TODO: Remove if error doesnt show up anymore
        console.warn("No stage found in this.$refs", this.$refs);
        return
      }
      let stage = this.$refs.stage.getNode();
      let stageWidth = stageSettings.width;
      let stageHeight = stageSettings.height;

      console.log("[VB] fitStageIntoParentContainer", stageSettings.canvasScaleMethod);

      if ( stageSettings.canvasScaleMethod === 'fit' ) {
        let container = document.querySelector('#stage-parent-fit');
        container = container || document.querySelector('#stage-parent-scroll'); // HACK
        /* now we need to fit stage into parent
           to do this we need to scale the stage */
        let containerWidth = container.offsetWidth;
        let scale = containerWidth / stageWidth;

        stage.width(stageWidth * scale);
        stage.height(stageHeight * scale);
        this.stageWidth = stageWidth // scale
        this.stageHeight = (stageHeight + 130) / scale
        if ( FIT_CANVAS_HEIGHT ) {
          stage.height( window.innerHeight - 50 /* height top bar */ );
          // this.stageHeight = window.innerHeight - 50
        }
        // if ( FIT_CANVAS_WIDTH ) {
        //   stage.width( window.innerWidth - 50 /* height top bar */ );
        // }
        stage.scale({ x: scale, y: scale });
        stage.draw();
      } else {
        stage.width(stageWidth);
        stage.height(stageHeight);
        this.stageWidth = stageWidth
        this.stageHeight = stageHeight
        if ( FIT_CANVAS_HEIGHT ) {
          let height = window.innerHeight
            - 50 /* height top bar */
            - (!FIT_CANVAS_WIDTH) * 20 /* height scroll bar */

          stage.height( height );
          this.stageHeight = height - 1
        }
        if ( FIT_CANVAS_WIDTH ) {
          let width = window.innerWidth
            - 40 /* width menu bar */
            - 0 * 300 /* session bar */
            - ( this.visionboard_edit_mode ) * 300 /* side bar */
            - ( this.visionboard_challenge_sidebar ) * 300 /* challenge side bar */
            - 10;

          stage.width(width);
          this.stageWidth = width - 1
        }
        stage.scale({ x: 1, y: 1 });
        stage.draw();
      }
    },

    boundBoxFunc(old_box, new_box) {
      console.log('olg_box:', old_box)
      return new_box;
    },

    unselect() {
      this.selection = { type: null, goalId: null, commitmentId: null, textId: null }
    },

    onHandleTextUpdate({ action, data }) {

      console.log("onHandleTextUpdate", action, data)
      // this.$refs.modalText.showTextUpdateForm(data);
      // this.$refs.modalText.showTextUpdateForm({ textId: textId });
      // console.log("DATA", data);
      // this.$root.showUpdateModal('text-visual', data).then(({ action, data }) => {
      // })

      if ( action === 'update' ) {
        this.addOrUpdateText(data);
      }

      if ( action === 'delete' ) {
        let idx = this.customTextClone.findIndex( item => item.textId === data.textId );
        delete this.customTextClone[idx];
        this.customTextClone = this.customTextClone.filter(item => item);
        // console.log("deleted at index", idx, this.customTextClone);
        this.onSaveCustomText();
        if ( this.getTransformer ) {
          this.getTransformer.detach();
        }
        this.unselect();
      }
    },

    onEditGoal( data ) {
      // this.$refs.modalGoal.showGoalUpdateForm(data);
      this.$root.showUpdateModal('goal', data).then(({ action }) => {
        if ( action === 'deleted' ) {
          console.log('[0] onGoalDeleted - deselecting');
          /* Let's deselect the goal and also remove the transformer */
          this.unselect();
          if ( this.getTransformer ) {
            this.getTransformer.detach();
          }
        }
      })
    },

    onShowSettingsModal() {
      this.$root.showModal('visionboard-settings').then(({ action, data }) => {
        if ( action === 'save' ) {
          this.initCanvas(data);
        }
        if ( action === 'export' ) {
          this.onExportCanvas(data.format, data.quality);
        }
      })
    },

    onClickGoal( data ) {
      // this.$refs.modalUserGoal.showUserGoalUpdateForm(data);
      this.$root.showUpdateModal('goal-visual', data);

    },

    onClickCommitment( data ) {
      // this.$refs.modalCommitment.showCommitmentUpdateForm(data);
      this.$root.showUpdateModal('effort', data);
    },

    onAddCommitment( data ) {
      // this.$refs.modalCommitment.showNewCommitmentForm(data);
      this.$root.showNewModal('effort', data);
    },

    onSnapText() {
      console.log("onSnapText - TODO");
    },

    onResetView() {
      let layer = this.$refs.layer.getNode();
      layer.scale({ x: 1, y: 1 });
      layer.position({ x: 0, y: 0 });
      layer.batchDraw();
    },

    onWheel(event) {
      // console.log("dx", event.evt.wheelDeltaX, "dy", event.evt.wheelDeltaY)
      const SCALE_SENSITIVITYY = 0.025;
      const MAX_ZOOM = 100
      const MIN_ZOOM = 0.01

      if ( ENABLE_VISIONBOARD_WHEEL_ZOOM && event.evt.shiftKey ) {
        this.zoom += event.evt.wheelDelta / 10000.0;
        event.evt.preventDefault();

        let stage = this.$refs.stage.getNode();
        let layer = this.$refs.layer.getNode();
        let oldScale = layer.scaleX();

        let mousePointTo = {
          x: stage.getPointerPosition().x / oldScale - layer.x() / oldScale,
          y: stage.getPointerPosition().y / oldScale - layer.y() / oldScale
        };

        let newScale = event.evt.wheelDelta > 0
                     ? oldScale * ( 1 + SCALE_SENSITIVITYY )
                     : oldScale / ( 1 + SCALE_SENSITIVITYY );

        newScale = Math.min( Math.max( MIN_ZOOM, newScale ), MAX_ZOOM )
        layer.scale({ x: newScale, y: newScale });

        let newPos = {
          x: -(mousePointTo.x - stage.getPointerPosition().x / newScale) * newScale,
          y: -(mousePointTo.y - stage.getPointerPosition().y / newScale) * newScale
        };

        layer.position(newPos);
        layer.batchDraw();

        /* Simple zoom:
        stage.scale({ x: 1 * this.zoom, y: 1 * this.zoom });
        // stage.scaleX(stage.scaleX() * scaleBy);
        // stage.scaleY(stage.scaleY() * scaleBy);
        stage.draw();
        */
      }
    },

    handleClickOrTap({ type,
      goalId = null,
      commitmentId = null,
      textId = null,
      node = null,
    }) {

      if ( !this.visionboard_edit_mode && type !== 'nothing' ) {
        return
      }

      console.log("*clock*", type);

      let allow_transformer = false;
      let data = null;

      switch (type) {
        case 'nothing':
          allow_transformer = true;
        break;

        case 'quote':
          allow_transformer = true;
        break

        case 'clock':
          allow_transformer = true;
        break

        case 'text':
          allow_transformer = true;
          data = this.texts.find(text => text.textId === textId );
        break

        case 'group':
          allow_transformer = true;
        break

        case 'headline':
        break

        case 'commitment':
        break

        case 'image':
        break

        default:
        console.warn('Not supported:', type);
      }

      // TODO: stop event bubbling is not supported?
      // event.evt.preventDefault(); // move to vision goal
      // event.evt.stopPropagation(); // move to vision goal
      this.selection = { type, goalId, commitmentId, textId, data }

      if ( allow_transformer && this.getTransformer ) {

        this.getTransformer.detach(); // ??

        if ( type !== 'nothing' ) {
          this.getTransformer.attachTo( node )
        }

        /* Set z-Index of Transformer */
        /*
        if ( goalId ) {
          let goal = this.all_my_user_goal_settings.find(item => item.$id === goalId);
          console.log("Settint Z-Index for transformer to", goal.sortidx + 1);
          console.log("this.getTransformer", this.getTransformer);
          this.getTransformer.setZIndex( goal.sortidx + 1 );
          this.getTransformer.draw();
        }
        */

        this.getTransformer.parent.draw();
        // this.getTransformer.forceUpdate();
        this.getTransformer.getStage().draw();
      }
    },

    handleStageClickOrTap(event) {
      // console.log("*click*", event);

      // TODO: Check if edit mode

      if (event.target === event.target.getStage()
        || event.target.attrs.height === 400000 /* Magic number */) {
        console.log("** click stage **");

        this.handleClickOrTap({ type: 'nothing' });
        // this.getTransformer.detach();
        // this.selection = { type: null, goalId: null, commitmentId: null, textId: null }
      }

      if (event.target.className === 'Path') {
        // THIS IS A BAD HACK
        console.log("** click icon **");
      }

      // this.getTransformer.destroy();
      // this.getTransformer.parent.draw();

      // console.log("handleStageMouseDown", event);
      /*
      // clicked on stage - cler selection
      if (event.target === event.target.getStage()) {
        this.selectedShapeName = "";
        this.updateTransformer(event);
        return;
      }
      // clicked on transformer - do nothing
      const clickedOnTransformer =
        event.target.getParent().className === "Transformer";
      if (clickedOnTransformer) {
        return;
      }
      // find clicked img by its name
      const name = event.target.name();
      this.selectedShapeName = name;
      this.updateTransformer(event);
      */
    },

    onAcceptInvitation(invitation_id, invitation_name, accept) {
      this.$api.accept_or_decline_invitation({
        goal_id: invitation_id,
        goal_name: invitation_name,
        accept: accept
      })
    },
  },
  components: {
    VGoal,
    VIcon,
    VButton,
    VClock,
    VQuote,
    VTextGroup,
    VGoalHeadline,
    VGoalImage,
    // VGoalCommitments,
    VisionboardSidebar,
    VisionboardChallengeSidebar,
  },
};
</script>

<style>
#stage-parent-fit {
  width: 100%;
}
#stage-parent-scroll > #stage-container {
  margin: 0;
  padding: 0;
  /* overflow: hidden; */
  background-color: #F0F0F0;
  height: 100%;
  overflow: auto;
}
/* width */
#stage-parent-scroll #stage-container::-webkit-scrollbar {
  width: 20px;
  height: 20px;
  background: black;
}
/* Track */
#stage-parent-scroll #stage-container::-webkit-scrollbar-track {
  /* border: 1px solid black; */
  /* border-radius: 10px; */
}
/* Handle */
#stage-parent-scroll #stage-container::-webkit-scrollbar-thumb {
  background: gray;
  border-radius: 20px;
}
/* Handle on hover */
#stage-parent-scroll #stage-container::-webkit-scrollbar-thumb:hover {
    background: #b30000;
}
.konvajs-content {
  background-color: #000000;
  fill: #ffffff
}
.stage-edit-mode-active #stage-container {
  /* border: 10px solid red; */
}
#stage-parent-scroll.stage-edit-mode-active > #stage-container {
  margin-right: 300px;
}
.visionboard-sidebar-container {
  display: block;
  border-left: 1px solid grey;
  background-color: white;
  width: 300px;
  position: absolute;
  right: 0;
  top: 0;
  margin-top: 50px;
  height: calc(100% - 50px);
  z-index: 99;
  overflow-y: scroll;
}
</style>
